export default "__VITE_ASSET__DPIshjRz__"